
export default {
    namespaced: true,
    state: {
        assetId: sessionStorage.getItem('assetId') || null,
    },

    mutations: {
        SET_NAME(state, assetId) {
            state.assetId = assetId;
            sessionStorage.setItem('assetId', assetId);
        },
    },
    actions: {
        setName({ commit }, assetId) {
            commit('SET_NAME', assetId);
        },
        
    },
}

  